import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { DatabaseProvider } from '../database/database';
import { SQLiteObject } from '@ionic-native/sqlite';

@Injectable()
export class CartaoCreditoProvider {

  constructor(public dbProvider: DatabaseProvider) {

  }

  async insert(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into cartoescredito(Cart_Codigo, Cart_Nome, Cart_Conta, Cart_Tipo, Cart_DiasCompensacao, Cart_Parcelas) values (?, ?, ?, ?, ?, ?)';
          for (let val of data) {
            let cartao = new CartaoCredito();
            cartao.codigo = val.Cart_Codigo;
            cartao.nome = val.Cart_Nome;
            cartao.conta = val.Cart_Conta;
            cartao.tipo = val.Cart_Tipo;
            cartao.dias_compensacao = val.Cart_DiasCompensacao;
            cartao.parcelas = val.Cart_Parcelas;
            let params = [cartao.codigo, cartao.nome, cartao.conta, cartao.tipo, cartao.dias_compensacao, cartao.parcelas];

            await tx.executeSql(sql, params, (tx, resultSet) => {
              console.log('importou cartão de crédito');
            }, (err) => {
              console.log('erro:' + err);
            });

          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  public removeAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'delete from cartoescredito';
        let data = [];

        return db.executeSql(sql, data)
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public getAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM cartoescredito order by Cart_Nome';

        return db.executeSql(sql, [])
          .then((data: any) => {
            if (data.rows.length > 0) {
              let cartoes: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var cartao = new CartaoCredito();
                cartao.codigo = data.rows.item(i).Cart_Codigo;
                cartao.nome = data.rows.item(i).Cart_Nome;
                cartao.conta = data.rows.item(i).Cart_Conta;
                cartao.tipo = data.rows.item(i).Cart_Tipo;
                cartao.dias_compensacao = data.rows.item(i).Cart_DiasCompensacao;
                if (data.rows.item(i).Cart_Parcelas <= 0) {
                  cartao.parcelas = 1;
                } else {
                  cartao.parcelas = data.rows.item(i).Cart_Parcelas;
                }
                cartoes.push(cartao);
              }
              return cartoes;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public get(codigo) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM cartoescredito where Cart_Codigo = ?';

        return db.executeSql(sql, [codigo])
          .then((data: any) => {
            var cartao = new CartaoCredito();
            if (data.rows.length > 0) {
              cartao.codigo = data.rows.item(0).Cart_Codigo;
              cartao.nome = data.rows.item(0).Cart_Nome;
              cartao.conta = data.rows.item(0).Cart_Conta;
              cartao.tipo = data.rows.item(0).Cart_Tipo;
              cartao.dias_compensacao = data.rows.item(0).Cart_DiasCompensacao;
              if (data.rows.item(0).Cart_Parcelas <= 0) {
                cartao.parcelas = 1;
              } else {
                cartao.parcelas = data.rows.item(0).Cart_Parcelas;
              }
            }
            return cartao;
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }
}

export class CartaoCredito {
  codigo: number;
  nome: string;
  conta: string;
  tipo: string;
  dias_compensacao: number;
  parcelas: number
}




// WEBPACK FOOTER //
// ./src/providers/cartao-credito/cartao-credito.ts